export const flagEmoji = (code) =>
  (code || "").length === 2
    ? String.fromCodePoint(...[...code.toUpperCase()].map((c) => 127397 + c.charCodeAt(0)))
    : "🌍";

let _dn = null;
export const countryName = (code, lang) => {
  try {
    if (!_dn || _dn.lang !== lang) _dn = Object.assign(new Intl.DisplayNames([lang || "en"], { type: "region" }), { lang });
    return _dn.of(code) || code;
  } catch {
    return code;
  }
};
